import {
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIco from "../../../assets/icons/BackArrowIco";
import Breadcrumbs from "../../../component/Breadcrumbs";
import CommonButton from "../../../component/Button";
import SnackBar from "../../../component/SnackBar/index";
import {
  GetReferenceCheck,
  GetReferenceStatus,
} from "../../../redux/action/Job";
import { HandleSkeletion } from "../../../utils/constants";
import { CustomDiv } from "../../chat-bot/style";
import {
  CommonGrid2,
  CustomAccordion,
  DotColor,
  StatusChange,
} from "../../common-components/StyledComponents";
import ExpandIco from "../../../assets/icons/ExpandIco";

export default function ReferenceCheckViewDetails() {
  const query = new URLSearchParams(useLocation().search);
  const jobTitle = query.get("title");
  const jobId = query.get("id");
  const queryValue = query.get("value");
  const matchId = query.get("match-id");
  const candidateName = query.get("candidate-name");
  const navigate = useNavigate();
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const breadCrumbData = [
    {
      title: "Jobs",
      navigate: "/jobs",
    },
    {
      title: jobTitle,
      navigate: `/jobs/jobs-view?id=${jobId}&title=${jobTitle}&value=${queryValue}&match-id=${matchId}`,
    },
    {
      title: "Reference Check",
      active: true,
    },
  ];
  const [referenceCheck, setReferenceCheck] = useState({
    data: [
      {
        name: "Shanmuka",
        email: "shanmukanathan.r@icanio.com",
        questions_answers: [
          {
            id: 1,
            question: "How are you?",
            answer: "3",
          },
          {
            id: 2,
            question: "How are you2?",
            answer: "Good",
          },
        ],
        pending: false,
      },
    ],
    loading: false,
  });

  useEffect(() => {
    fetchInterviewKitData();
  }, [matchId]);

  const fetchInterviewKitData = async () => {
    setReferenceCheck((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      const response = await GetReferenceStatus(matchId);
      console.log(response, "sfkjshfkjsfjkskjskln");
      setReferenceCheck((prev) => ({
        ...prev,
        data: response.references,
        loading: false,
      }));
    } catch (error) {
      setReferenceCheck((prev) => ({
        ...prev,
        error: error,
        loading: false,
      }));
      setSnackbarState((prev) => ({
        ...prev,
        message: error.message,
        severity: "error",
      }));
    }
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  return (
    <CustomDiv
      height={"100vh"}
      background={"#F6F8FB"}
      display={"flex"}
      overflowY={"auto"}
    >
      <CommonGrid2
        width={"100%"}
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        background="#fff"
        borderRadius={"10px"}
        height={"fit-content"}
        padding={"1rem"}
        margin={"1.35rem 1rem 1.35rem 1.35rem"}
      >
        <Breadcrumbs breadCrumbData={breadCrumbData} />
        <CommonGrid2
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          padding={"1rem 0px 0px 0px"}
        >
          <CustomDiv
            display={"flex"}
            width={"max-content"}
            alignItems={"center"}
            gap={"0rem"}
            justifyContent={"center"}
            customStyle={{
              flexDirection: "column",
            }}
          >
            <Typography variant="h3">
              {candidateName
                ? `${candidateName}'s Reference Check`
                : "Reference Check"}
            </Typography>
            <Typography
              variant="subtitle2"
              fontWeight={500}
              color={"#475467"}
              marginTop={"5px"}
            >
              {jobTitle || ""}
            </Typography>
          </CustomDiv>
          <CommonGrid2 display={"flex"} gap={"1rem"}>
            <CommonButton
              value={"Back"}
              startIcon={<BackArrowIco />}
              gap={"0px"}
              variant="outlined"
              color="#344054"
              padding={"8px 1.5rem"}
              fontWeight={"700"}
              fontSize={"15px"}
              border={"#D0D5DD"}
              width="auto"
              customStyle={{
                "&:hover svg path": {
                  stroke: "#fff",
                },
              }}
              onClick={() => navigate(-1)}
            />
          </CommonGrid2>
        </CommonGrid2>

        <CommonGrid2 marginTop={"2rem"} width={"100%"}>
          {referenceCheck.loading ? (
            Array.from({ length: 3 }).map((_, index) => (
              <HandleSkeletion
                key={index}
                height="50px"
                width="100%"
                transform={"scale(1)"}
                margin="1rem 0px"
              />
            ))
          ) : (
            <CommonGrid2 container spacing={2} size={12} width={"100%"}>
              {referenceCheck?.data &&
                referenceCheck?.data?.map((details, _) => {
                  if (details.questions_answers.length === 0) return null;
                  return (
                    <CustomAccordion
                      width="100%"
                      padding="0px"
                      ContentMargin={"0px !important"}
                      paddingBottom={"1rem"}
                      defaultExpanded={_ === 0}
                      customStyle={{
                        "& .MuiAccordionSummary-expandIconWrapper": {
                          border: "1px solid #D0D5DD",
                          borderRadius: "5px",
                          padding: "15px",
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandIco />}
                        aria-controls={`panel${_}-content`}
                        id={`panel${_}-header`}
                      >
                        <CommonGrid2
                          display={"flex"}
                          alignItems={"center"}
                          gap={"10px"}
                        >
                          <Avatar
                            alt="Olivia Rhye"
                            sx={{ width: 40, height: 40, fontWeight: "700" }}
                          >
                            {details.name
                              .split(" ")
                              .map((word) => word.charAt(0))
                              .join("")
                              .toUpperCase()}
                          </Avatar>
                          <CommonGrid2
                            display={"flex"}
                            size={12}
                            gap={"2px"}
                            flexDirection={"column"}
                          >
                            <CommonGrid2 display={"flex"} gap={"10px"}>
                              <Typography variant="h4" fontWeight={600}>
                                {details.name}
                              </Typography>
                              <StatusChange fontSize={"14px"}>
                                <DotColor
                                  color={
                                    details.pending !== null ? "green" : "red"
                                  }
                                />
                                {details.pending !== null
                                  ? "Submitted"
                                  : "Pending"}
                              </StatusChange>
                            </CommonGrid2>
                            <Typography
                              variant="body4"
                              color="#475467"
                              fontWeight={600}
                            >
                              {details.email}
                            </Typography>
                          </CommonGrid2>
                        </CommonGrid2>
                      </AccordionSummary>
                      <AccordionDetails>
                        <CommonGrid2
                          container
                          spacing={2}
                          size={12}
                          marginTop={"1.5rem"}
                        >
                          {details.questions_answers.map((item, index) => (
                            <CommonGrid2
                              key={index}
                              size={{ xs: 12, sm: 6 }}
                              width="100%"
                              border="1px solid rgba(0, 0, 0, 0.12)"
                              background="#fff"
                              borderRadius="10px"
                              padding="12px 15px 10px"
                              height="initial"
                              display={"flex"}
                              flexDirection={"column"}
                              gap={"10px"}
                              justifyContent={"space-between"}
                            >
                              <Typography
                                variant="body2"
                                fontWeight={600}
                                color="#475467"
                              >
                                {index + 1}. {item.question}
                              </Typography>

                              <Typography variant="h5" color="#101828">
                                {item.answer}
                              </Typography>
                            </CommonGrid2>
                          ))}
                        </CommonGrid2>
                      </AccordionDetails>
                    </CustomAccordion>
                  );
                })}
            </CommonGrid2>
          )}
        </CommonGrid2>
      </CommonGrid2>

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </CustomDiv>
  );
}
